var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "#59C3C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65625 11L10.3438 11L10.3438 12.3438L5.65625 12.3438L5.65625 11ZM5.65625 8.34375L12.3438 8.34375L12.3438 9.65625L5.65625 9.65625L5.65625 8.34375ZM5.65625 5.65625L12.3438 5.65625L12.3438 7L5.65625 7L5.65625 5.65625ZM13.6563 3L10.875 3C10.5938 2.21875 9.875 1.65625 9 1.65625C8.125 1.65625 7.40625 2.21875 7.125 3L4.34375 3C4.25 3 4.15625 3 4.0625 3.03125C3.8125 3.09375 3.5625 3.21875 3.40625 3.40625C3.28125 3.5 3.1875 3.65625 3.09375 3.8125C3.03125 3.96875 3 4.15625 3 4.34375L3 13.6563C3 13.8438 3.03125 14.0313 3.09375 14.1875C3.1875 14.3438 3.28125 14.5 3.40625 14.625C3.5625 14.7813 3.8125 14.9375 4.0625 14.9688C4.15625 15 4.25 15 4.34375 15L13.6563 15C14.4063 15 15 14.4063 15 13.6563L15 4.34375C15 3.59375 14.4063 3 13.6563 3ZM9 2.84375C9.28125 2.84375 9.5 3.0625 9.5 3.34375C9.5 3.59375 9.28125 3.84375 9 3.84375C8.71875 3.84375 8.5 3.59375 8.5 3.34375C8.5 3.0625 8.71875 2.84375 9 2.84375ZM13.6563 13.6563L4.34375 13.6563L4.34375 4.34375L13.6563 4.34375L13.6563 13.6563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPlanIcon);
export default __webpack_public_path__ + "static/media/action_plan_icon.b065b64f72a9996d9651495b82b179be.svg";
export { ForwardRef as ReactComponent };